var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUploadAlt = function SvgUploadAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 21",
    style: {
      enableBackground: "new 0 0 20 21"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 5.9c-.6.5-.7 1.5-.1 2.1s1.5.7 2.1.1l2-1.8v6.2c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5V6.3l2 1.8c.6.6 1.6.5 2.1-.1.6-.6.5-1.6-.1-2.1L10 1 4.5 5.9zM5 15.5c0-.8-.7-1.5-1.5-1.5S2 14.7 2 15.5v4c0 .8.7 1.5 1.5 1.5h13c.8 0 1.5-.7 1.5-1.5v-4c0-.8-.7-1.5-1.5-1.5s-1.5.7-1.5 1.5V18H5v-2.5z"
  })));
};
export default SvgUploadAlt;